<template>
    <div class="list-content">
        <el-input type="textarea" id="content" v-model="content" rows="10"></el-input>
    </div>
</template>

<script>
import summernote from "@/mixins/summernote";
import termsUtil from "@/components/terms/termsUtil";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";

export default {
    name: "TermsJstComponent",
    mixins: [summernote, termsUtil, alertMixins],
    components: {},
    provide() {
        return {}
    },
    props: {
        termsType: {},
        cid: '',
        cs_idx:'',
    },
    data() {
        return {
            termsKey: '',
            content: '',
        }
    },
    created() {
        this.initConfig();
    },
    mounted() {
        this.initSummernote('content', '내용', 'content');
        this.getTerms();
        EventBus.$on('writeTerms', this.writeTerms)
    },
    beforeDestroy() {
        EventBus.$off('writeTerms')

    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnTermsConfig(this.termsType);
            this.termsKey = config.termsKey;
        },
        getTerms() {
            let params = {
                c_type: 'service',
                cid: this.cid
            }
            try {
                this.$api.$config.getTerms(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        this.errorAlert('서비스 이용약관을 불러올 수 없습니다.');
                        return;
                    }
                    this.cs_idx = res.List[0].cs_idx;
                    let termsObj = res.List[0];
                    this.content = termsObj[this.termsKey];
                    this.content = util.htmlDecode(this.content);
                    $('#content').summernote('code', this.content);
                })
            } catch (e) {
                console.log(e);
            }
        },
        writeTerms() {
            if (this.content == '' || this.content === '<p><span style="font-size: 14px;">﻿</span><br></p>') {
                this.errorAlert('모두 입력해주세요');
                return;
            }
            let params = {
                c_type: 'service',
                cs_idx: this.cs_idx,
            }
            params[this.termsKey] = this.content;

            try {
                this.$api.$config.updateTerms(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        this.errorAlert('작성에 실패하였습니다.');
                        return false;
                    }
                    this.createAlert({
                        content: '저장되었습니다.',
                        hide: () => {
                            this.$router.back();
                        }
                    })
                })
            } catch (e) {
                console.log(e);
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
